let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2raGt")).then(() => parcelRequire('3SDbS'));